import { render, staticRenderFns } from "./NsToast.vue?vue&type=template&id=30d4898f&scoped=true&"
import script from "./NsToast.vue?vue&type=script&lang=js&"
export * from "./NsToast.vue?vue&type=script&lang=js&"
import style0 from "./NsToast.vue?vue&type=style&index=0&id=30d4898f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d4898f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
